module.exports = __webpack_public_path__ + "img/born-a-crime.4ab27a65.png";